<template>
    <div>
      <h6 class="heading-small text-muted mb-4"> {{this.$attrs.ecomAction + " " + documentDetails.id}}</h6>
      <hr class="mb-0 mt-0">
      {{documentDetails.order_souce}}
      <a-spin :spinning="spinning">
            <div class="card mt-3 border-0">
                <base-alert v-if="errors.length" type="danger" class="mb-0">
                    <b>You have the following error(s):</b>
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </base-alert>
                <base-input label="Select Reason to cancel" required v-if="this.$attrs.ecomAction =='Void'">
                    <a-select v-if="documentDetails.order_source=='lazada'" v-model="lazadaSelectedReason" size="large" placeholder="Select Reason to cancel" style="width: 100%" :filterOption="filterOption">
                        <a-select-option v-for="option in LazadaReasonsToCancelData" :key="option.reason_id" :value="option.reason_id">{{option.name}}</a-select-option>
                    </a-select>
                    <a-select v-if="documentDetails.order_source=='zalora'" v-model="zaloraSelectedReason" size="large" placeholder="Select Reason to cancel" style="width: 100%" :filterOption="filterOption">
                        <a-select-option v-for="option in ZaloraReasonsToCancelData" :key="option.id" :value="option.name">{{option.name}}</a-select-option>
                    </a-select>
                    <a-select v-if="documentDetails.order_source=='shopify'" v-model="shopifySelectedReason" size="large" placeholder="Select Reason to cancel" style="width: 100%" :filterOption="filterOption">
                        <a-select-option value="customer">Customer changed/canceled order</a-select-option>
                        <a-select-option value="inventory">Item unavailable</a-select-option>
                        <a-select-option value="fraud">Fraudulent order</a-select-option>
                        <a-select-option value="declined">Payment declined</a-select-option>
                        <a-select-option value="other">Others</a-select-option>
                    </a-select>
                    <a-select v-if="documentDetails.order_source=='shopee'" v-model="shopeeSelectedReason" size="large" placeholder="Select Reason to cancel" style="width: 100%" :filterOption="filterOption">
                        <a-select-option value="OUT_OF_STOCK">Out of stock</a-select-option>
                        <a-select-option value="UNDELIVERABLE_AREA">Undeliverable area</a-select-option>
                        <a-select-option value="COD_NOT_SUPPORTED">Cannot support COD for this buyer</a-select-option>
                    </a-select>
                </base-input>
                <div v-if="this.$attrs.ecomAction =='Post'">
                    <table class="table table-bordered" v-if="documentDetails.order_source=='lazada'">
                        <thead>
                            <tr style="background-color: #f7f8fa">
                                <td scope="col">Order Nr.</td>
                                <td scope="col">Provider</td>
                                <td scope="col">Tracking ID</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="data in lazadaOrderLineDetails">
                                <td>{{data.order_item_id}}</td>
                                <td>{{data.shipment_provider}}</td>
                                <td>{{data.tracking_code}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-bordered" v-if="documentDetails.order_source == 'zalora'">
                        <thead>
                        <tr style="background-color: #f7f8fa">
                            <td scope="col">Order Nr.</td>
                            <td scope="col">Provider</td>
                            <td scope="col">Tracking ID</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in zaloraOrderLineDetails">
                            <td>{{ data.id }}</td>
                            <td>{{ data.shipment.provider["name"] }}</td>
                            <td>{{ data.shipment.trackingCode }}</td>
                        </tr>
                        </tbody>
                    </table>

                    <div v-if="documentDetails.order_source=='shopee' && shopeeLogisticInfo.pickup != null">
                        <base-input label="Arrange Pickup" required v-if="shopeeLogisticInfo.pickup.address_list.length > 0">
                            <a-select v-model="shopeeSelectedLogistic" style="width: 100%" placeholder="Select Pickup Address" :filterOption="filterOption" @change="onChangeShopeeSelectedLogistic(shopeeSelectedLogistic)">
                                <a-select-option v-for="(option, optionIndex) in shopeeLogisticInfo.pickup.address_list" :key="optionIndex" :value="optionIndex"> {{option.address + ' ' + option.town + ', ' + option.district+' '+ option.country+', '+ option.city}}</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input label="Date" required v-if="shopeeSelectedLogisticInfo.address_id!=null">
                            <a-select v-model="shopeeSelectedLogisticInfo.pickup_time_id" style="width: 100%" placeholder="Select Pickup Address" :filterOption="filterOption" @change="onChangeShopeeSelectedLogistic(shopeeSelectedLogistic)">
                                <a-select-option v-for="(option, optionIndex) in shopeeSelectedLogisticInfo.time_slot_list" :key="optionIndex" :value="option.pickup_time_id">{{formatDate(option.date)}}</a-select-option>
                            </a-select>
                        </base-input>
                    </div>
                </div>
            </div>
      </a-spin>
      <div>
        <div v-if="serverType == 'ho' && spinning == false" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <a-button type="primary" size="large" :loading="shopifySetCancelStatusLoading"  v-if="this.$attrs.ecomAction =='Void' && documentDetails.order_source=='shopify'" class="btn btn-primary float-right" @click.prevent="setShopifyOrderStatusToCancel">Void</a-button>
            <a-button type="primary" size="large" :loading="shopeeSetCancelStatusLoading" v-if="this.$attrs.ecomAction =='Void' && documentDetails.order_source=='shopee'" class="btn btn-primary float-right" @click.prevent="setShopeeOrderStatusToCancel">Void</a-button>
            <a-button type="primary" size="large" :loading="lazadaSetCancelStatusLoading" v-if="this.$attrs.ecomAction =='Void' && documentDetails.order_source=='lazada'" class="btn btn-primary float-right" @click.prevent="setLazadaOrderStatusToCancel">Void</a-button>
            <a-button type="primary" size="large" :loading="setLazadaOrderStatusToReadyToShipLoading" v-if="this.$attrs.ecomAction =='Post' && documentDetails.order_source=='lazada'" class="btn btn-primary float-right" @click.prevent="setLazadaOrderStatusToReadyToShip">Post</a-button>
            <a-button type="primary" size="large" :loading="zaloraSetCancelStatusLoading" v-if=" this.$attrs.ecomAction == 'Void' && documentDetails.order_source == 'zalora' " class="btn btn-primary float-right" @click.prevent="setZaloraOrderStatusToCancel">Void</a-button>
            <a-button type="primary" size="large" :loading="setZaloraOrderStatusToReadyToShipLoading" v-if=" this.$attrs.ecomAction == 'Post' && documentDetails.order_source == 'zalora' " @click.prevent="setZaloraOrderStatusToReadyToShip">Post</a-button>
            <a-button type="primary" size="large" :loading="arrangeShopeeOrderPickupLoading" v-if="this.$attrs.ecomAction =='Post' && documentDetails.order_source=='shopee'" class="btn btn-primary float-right" @click.prevent="arrangeShopeeOrderPickup">Post</a-button>
            <button type="button" class="btn btn-secondary float-right mr-2" @click.prevent="$emit('closeDrawer', null)">Cancel</button> 
        </div>
      </div>
    </div>
</template>
<script>
    import axios from "axios";
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import { mapState } from 'vuex'
    import moment from 'moment';
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
           this.spinning = true
           this.documentDetails = this.$attrs.documentDetails
           var check_sales_channel = await HTTPRequest.getRequest(this.endPoint + 'orders/check_sales_channel?document_id='+this.documentDetails.id, null)    
            if (check_sales_channel["error"] != undefined) {
                if(this.$attrs.ecomAction =='Void'){
                    this.$emit('deleteRow', this.documentDetails.id)
                    this.$emit('closeDrawer', null)
                }else if (this.$attrs.ecomAction =='Post'){
                    this.$emit('postOrder', this.documentDetails.id)
                    this.$emit('closeDrawer', null)
                }
            } 
            switch (true) {
                case (this.documentDetails.order_source == "lazada" && this.$attrs.ecomAction =='Void'):
                    await this.getLazadaReasonsToCancel(this.documentDetails.id)
                break;
                case (this.documentDetails.order_source == "lazada" && this.$attrs.ecomAction =='Post'):
                    await this.setLazadaOrderStatusToPacked(this.documentDetails.id)
                break;
                case this.documentDetails.order_source == "zalora" &&
                this.$attrs.ecomAction == "Void":
                await this.getZaloraReasonsToCancel(this.documentDetails.id);
                break;
                case this.documentDetails.order_source == "zalora" &&
                this.$attrs.ecomAction == "Post":
                await this.setZaloraOrderStatusToPacked(this.documentDetails.id);
                break;
                case (this.documentDetails.order_source == "shopee" && this.$attrs.ecomAction =='Post'):
                    await this.getShopeeLogisticInfo(this.documentDetails.id)
                break;
                default:
                break;
            }
            this.spinning = false
        },
        data() {
            return {
                spinning:false,
                documentDetails:{},
                LazadaReasonsToCancelData:[],
                lazadaSelectedReason:null,
                ZaloraReasonsToCancelData: [],
                zaloraSelectedReason: null,
                shopifySelectedReason:null,
                shopeeSelectedReason:null,
                shopeeSetCancelStatusLoading:false,
                shopifySetCancelStatusLoading:false,
                lazadaSetCancelStatusLoading:false,
                setLazadaOrderStatusToReadyToShipLoading:false,
                zaloraSetCancelStatusLoading: false,
                setZaloraOrderStatusToReadyToShipLoading: false,
                lazadaShipmentProvider:null,
                lazadaDeliveryType:null,
                lazadaOrderLineDetails:[],
                lazadaOrderItemIds:[],
                zaloraShipmentProvider: null,
                zaloraDeliveryType: null,
                zaloraOrderLineDetails: [],
                zaloraOrderItemIds: [],
                shopeeLogisticInfo:[],
                shopeeSelectedLogistic:null,
                shopeeSelectedLogisticInfo:{
                    address_id:null,
                    time_slot_list:[],
                    pickup_time_id:null
                },
                arrangeShopeeOrderPickupLoading:false,
                errors:[]
            };
        },
        methods: {
            getLazadaReasonsToCancel: async function(document_id){
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'lazada_integrations/get_reasons_to_cancel', null, {document_id:document_id})    
                if (post_request["error"] == undefined) {
                    this.LazadaReasonsToCancelData = post_request["data"]
                } else {
                    this.errors = post_request["error"].split(",")
                }
            },
            getZaloraReasonsToCancel: async function (document_id) {
                var post_request = await HTTPRequest.postRequest(
                    this.endPoint + "zalora_integrations/get_reasons_to_cancel",
                    null,
                    { document_id: document_id }
                );
                if (post_request["error"] == undefined) {
                    this.ZaloraReasonsToCancelData = post_request;
                } else {
                    this.errors = post_request["error"].split(",");
                }
            },

            setCancelValidation(ecom){
                this.errors = [];
                switch (ecom) {
                    case "shopee":
                        this.errors.push(ValidateField.required('Cancel reason', this.shopeeSelectedReason));
                    break;
                    case "lazada":
                        this.errors.push(ValidateField.required('Cancel reason', this.lazadaSelectedReason));
                    break;
                    case "shopify":
                        this.errors.push(ValidateField.required('Cancel reason', this.shopifySelectedReason));
                    break;
                    case "zalora":
                    this.errors.push(
                        ValidateField.required("Cancel reason", this.zaloraSelectedReason)
                    );
                    break;
                
                    default:
                    break;
                }
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            setLazadaOrderStatusToCancel: async function(){
                if(!this.setCancelValidation("lazada")) {
                    this.lazadaSetCancelStatusLoading = true
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'lazada_integrations/set_status_to_canceled', null, {document_id:this.documentDetails.id,cancel_reason:this.lazadaSelectedReason})    
                    if (post_request["error"] == undefined) {
                        console.log(post_request)
                        this.lazadaSetCancelStatusLoading = false
                        this.$emit('deleteRow', this.documentDetails.id)
                        this.$emit('closeDrawer', null)
                    } else {
                        this.errors = post_request["error"].split(",")
                        this.lazadaSetCancelStatusLoading = false
                    }
                }
            },
            setShopeeOrderStatusToCancel:async function(){
                if(!this.setCancelValidation("shopee")) {
                    this.shopeeSetCancelStatusLoading = true
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'shopee_integrations/set_status_to_canceled', null, {document_id:this.documentDetails.id,cancel_reason:this.shopeeSelectedReason})    
                    if (post_request["error"] == undefined) {
                        console.log(post_request)
                        this.shopeeSetCancelStatus = false
                        this.$emit('deleteRow', this.documentDetails.id)
                        this.$emit('closeDrawer', null)
                    } else {
                        this.errors = post_request["error"]["msg"].split(",")
                        this.shopeeSetCancelStatusLoading = false
                    }
                }
            },
            setShopifyOrderStatusToCancel:async function(){
                if(!this.setCancelValidation("shopify")) {
                    this.shopifySetCancelStatusLoading = true
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'shopify_integrations/set_status_to_canceled', null, {document_id:this.documentDetails.id,cancel_reason:this.shopifySelectedReason})    
                    if (post_request["error"] == undefined) {
                        console.log(post_request)
                        this.shopifySetCancelStatus = false
                        this.$emit('deleteRow', this.documentDetails.id)
                        this.$emit('closeDrawer', null)
                    } else {
                        this.errors = post_request["error"].split(",")
                        this.shopifySetCancelStatusLoading = false
                    }
                }
            },
            setZaloraOrderStatusToCancel: async function () {
            if (!this.setCancelValidation("zalora")) {
                this.zaloraSetCancelStatusLoading = true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + "zalora_integrations/set_status_to_canceled",null,{document_id: this.documentDetails.id, cancel_reason: this.zaloraSelectedReason,});
                if (post_request["error"] == undefined) {
                    console.log(post_request);
                    this.zaloraSetCancelStatus = false;
                    this.$emit("deleteRow", this.documentDetails.id);
                    this.$emit("closeDrawer", null);
                } else {
                    this.errors = post_request["error"].split(",");
                    this.shopifySetCancelStatusLoading = false;
                }
            }
            },

            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            setLazadaOrderStatusToPacked: async function(document_id){
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'lazada_integrations/get_shipment_providers', null, {document_id:document_id})
                if (post_request["error"] == undefined) {
                    var deliveryTypes = ['dropship','pickup','send_to_warehouse'];
                    var shipment_provider = '';
                    var delivery_type = '';
                    post_request["shipment_providers"]["data"]["shipment_providers"].forEach(function(item) {
                        var value = post_request["lines"]["data"][0].shipment_provider.search(item.name);
                        if (value>=0){
                            shipment_provider = item.name;
                        }else{
                            if (shipment_provider== '' || shipment_provider == null){
                                shipment_provider = "LEX PH";
                            }
                        }
                    });
                    deliveryTypes.forEach(function(item){
                        var checkDeliveryType = post_request["lines"]["data"][0].shipping_type.toLowerCase().search(item);
                        if (checkDeliveryType>=0){
                            delivery_type = item;
                        }
                    });
                    var order_item_ids = [];
                    let tracking_code_status = true
                    post_request["lines"]["data"].forEach(function(item){
                        order_item_ids.push(item.order_item_id);
                        if (item.tracking_code !=null && item.tracking_code!="" && item.tracking_code!=undefined){
                            tracking_code_status = false
                        }
                    });

                    this.lazadaShipmentProvider = shipment_provider
                    this.lazadaDeliveryType = delivery_type
                    this.lazadaOrderItemIds = order_item_ids
                    if (tracking_code_status){
                        var set_status_to_packed = await HTTPRequest.postRequest(this.endPoint + 'lazada_integrations/set_status_to_packed_by_market_place', null, {document_id:document_id,shipment_provider:shipment_provider,delivery_type:delivery_type,order_item_ids:order_item_ids})
                        if (set_status_to_packed["error"] == undefined) {
                            this.lazadaOrderLineDetails = set_status_to_packed["lines"]["data"]
                        } else {
                            this.errors = set_status_to_packed["error"].split(",")
                        }
                    }else{
                        this.lazadaOrderLineDetails = post_request["lines"]["data"]
                    }
                } else {
                    this.errors = post_request["error"].split(",")
                }
            },
            setLazadaOrderStatusToReadyToShip: async function(){
                this.setLazadaOrderStatusToReadyToShipLoading = true
                var payload = {
                    document_id:this.documentDetails.id,
                    shipment_provider:this.lazadaShipmentProvider,
                    delivery_type:this.lazadaDeliveryType,
                    order_item_ids:this.lazadaOrderItemIds,
                    tracking_code:this.lazadaOrderLineDetails[0]["tracking_code"]
                }
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'lazada_integrations/set_status_to_ready_to_ship', null, payload)   
                console.log(post_request) 
                if (post_request["error"] == undefined) {
                    this.setLazadaOrderStatusToReadyToShipLoading = false
                    this.$emit('postOrder', this.documentDetails.id)
                    this.$emit('closeDrawer', null)
                }else{
                    this.errors = post_request["error"].split(",")
                    this.setLazadaOrderStatusToReadyToShipLoading = false
                }
            },

            setZaloraOrderStatusToPacked: async function (document_id) {
            var post_request = await HTTPRequest.postRequest(
                this.endPoint + "zalora_integrations/get_shipment_providers",
                null,
                { document_id: document_id }
            );
            console.log(post_request);
            if (post_request["error"] == undefined) {
                var deliveryTypes = ["dropship", "pickup", "send_to_warehouse"];
                var shipment_provider = "";
                var delivery_type = "";
                var tracking_code = "";
                console.log(post_request["shipment_providers"][0]);
                post_request["shipment_providers"].forEach(function (item) {
                var value = post_request["lines"][0].shipment.provider.name.search(item.name);
                    if (value >= 0) {
                        shipment_provider = item.name;
                    } else {
                        if (shipment_provider == "" || shipment_provider == null) {
                        shipment_provider = "Express MP";
                        }
                    }
                    });
                    deliveryTypes.forEach(function (item) {
                    var checkDeliveryType = post_request["lines"][0].shipment.type
                        .toLowerCase()
                        .search(item);
                    if (checkDeliveryType >= 0) {
                        delivery_type = item;
                    }
                    });
                    var order_item_ids = [];
                    let tracking_code_status = true;
                    post_request["lines"].forEach(function (item) {
                    order_item_ids.push(item.id);
                    if (
                        item.shipment["trackingCode"] != null &&
                        item.shipment["trackingCode"] != "" &&
                        item.shipment["trackingCode"] != undefined
                    ) {
                        tracking_code = item.shipment["trackingCode"];
                        // tracking_code_status = false
                    }
                    });
                    this.zaloraShipmentProvider = shipment_provider;
                    this.zaloraDeliveryType = delivery_type;
                    this.zaloraOrderItemIds = order_item_ids;
                    console.log(
                    this.zaloraShipmentProvider,
                    this.zaloraDeliveryType,
                    this.zaloraOrderItemIds
                    );

                    if (tracking_code_status) {
                    var set_status_to_packed = await HTTPRequest.postRequest(
                        this.endPoint + "zalora_integrations/set_status_to_packed_by_market_place",
                        null,
                        {
                        document_id: document_id,
                        shipment_provider: shipment_provider,
                        delivery_type: delivery_type,
                        order_item_ids: order_item_ids,
                        tracking_code: tracking_code,
                        }
                    );
                    if (set_status_to_packed["error"] == undefined) {
                        this.zaloraOrderLineDetails = set_status_to_packed["lines"];
                    } else {
                        this.errors = set_status_to_packed["error"].split(",");
                    }
                    } else {
                    this.zaloraOrderLineDetails = post_request["lines"];
                    }
                } else {
                    this.errors = post_request["error"].split(",");
                }
            },

            setZaloraOrderStatusToReadyToShip: async function () {
                this.setZaloraOrderStatusToReadyToShipLoading = true;
                var payload = {
                    document_id: this.documentDetails.id,
                    shipment_provider: this.zaloraShipmentProvider,
                    delivery_type: this.zaloraDeliveryType,
                    order_item_ids: this.zaloraOrderItemIds,
                    tracking_code: this.zaloraOrderLineDetails[0]["shipment"]["trackingCode"],
                };
                var post_request = await HTTPRequest.postRequest(
                    this.endPoint + "zalora_integrations/set_status_to_ready_to_ship",
                    null,
                    payload
                );
                console.log(post_request);
                if (post_request["error"] == undefined) {
                    this.setZaloraOrderStatusToReadyToShipLoading = false;
                    this.$emit("postOrder", this.documentDetails.id);
                    this.$emit("closeDrawer", null);
                } else {
                    this.errors = post_request["error"].split(",");
                    this.setZaloraOrderStatusToReadyToShipLoading = false;
                }
            },

            getShopeeLogisticInfo:async function(document_id){
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'shopee_integrations/get_logistic_info', null, {document_id:document_id})   
                if (post_request["error"] == undefined) {
                    this.shopeeLogisticInfo = post_request
                }else{
                    this.errors = post_request["error"].split(",")
                }
            },
            onChangeShopeeSelectedLogistic(index){
                try {
                    this.shopeeSelectedLogisticInfo.address_id = this.shopeeLogisticInfo.pickup.address_list[index].address_id
                this.shopeeSelectedLogisticInfo.time_slot_list = this.shopeeLogisticInfo.pickup.address_list[index].time_slot_list
                } catch (error) {}
            },
            formatDate(value) {
                if (value) {
                    return moment.unix(value).format('MM/DD/YYYY ddd')
                }
            },
            arrangeShopeeOrderPickupValidation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Address', this.shopeeSelectedLogisticInfo.address_id));
                this.errors.push(ValidateField.required('Date', this.shopeeSelectedLogisticInfo.pickup_time_id));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            arrangeShopeeOrderPickup: async function(){
                if(!this.arrangeShopeeOrderPickupValidation()) {
                    this.arrangeShopeeOrderPickupLoading = true
                    var payload = {
                        document_id:this.documentDetails.id,
                        address_id:this.shopeeSelectedLogisticInfo.address_id,
                        pickup_time_id:this.shopeeSelectedLogisticInfo.pickup_time_id
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'shopee_integrations/logistics_init', null, payload)   
                    if (post_request["error"] == undefined) {
                        this.arrangeShopeeOrderPickupLoading = false
                        this.$emit('postOrder', this.documentDetails.id)
                        this.$emit('closeDrawer', null)
                    }else{
                        this.arrangeShopeeOrderPickupLoading = false
                        this.errors = post_request["error"].split(",")
                    }
                }
            }
        },
    };
</script>
<style>
</style>
<style lang='scss'>
    @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
</style>